module.exports = __webpack_public_path__ + "static/media/LaBelleAurore-Regular.927c351a.ttf";